import UpdateFlightInfoModal from './UpdateFlightInfoModal';

export default UpdateFlightInfoModal;
